import React from 'react';

interface Props {
  children: React.ReactNode;
  heading?: string;
  headingId?: string;
}

const FooterColumn: React.FC<Props> = (props) => {
  const {
    children,
    heading,
    headingId,
  } = props;

  return (
    <div className="Footer__column">
      {heading && (
        <h2 className="Footer__heading" id={headingId}>
          {heading}
        </h2>
      )}
      {children}
    </div>
  );
};

export default FooterColumn;
